<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-13 14:01:52
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-26 16:36:33
 * @Description: 勾组件
 * @FilePath: /hsylc2021/src/components/icons/Tick/index.vue
-->
<template>
  <div class="icon-tick" :class="computedClass" :style="componentStyle">
    <div class="tick-content" :style="contentStyle"></div>
  </div>
</template>
<script>
/**
 * 打勾图标
 * @module Tick
 */
export default {
  name: 'Tick',
  /**
   * @prop {String} className 外部class
   * @prop {String} color 图标颜色 默认#20c25D
   * @prop {Number} lineScare 长短线条比例 默认 3/5
   * @prop {String} width 组件大小 默认24px
   * @prop {String} weight 线图粗细 默认2px
   * @prop {Number} percent 最长边对应组件宽度百分比 默认75
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#20C25D'
    },
    lineScare: {
      type: Number,
      default: 3 / 5
    },
    width: {
      type: String,
      default: '24px'
    },
    weight: {
      type: String,
      default: '2px'
    },
    percent: {
      type: Number,
      default: 75
    }
  },
  /**
   * @prop {Object} computedClass 计算后的class
   * @prop {Object} computedStyle 组件样式
   * @prop {Object} contentStyle 横线样式
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      return ret;
    },
    componentStyle() {
      let ret = {};
      ret.width = ret.height = this.width;
      return ret;
    },
    contentStyle() {
      let ret = {};
      ret.width = `${this.percent}%`;
      ret.height = `${this.percent * this.lineScare}%`;
      ret.borderWidth = this.weight;
      ret.borderColor = this.color;
      return ret;
    }
  }
};
</script>
<style lang="less" scoped>
.icon-tick {
  display: flex;
  align-items: center;
  justify-content: center;
  .tick-content {
    border-style: solid;
    border-top: 0;
    border-right: 0;
    transform: translate(35%, 16%) rotate(-45deg);
    transform-origin: 0 100%;
  }
}
</style>
